import React from 'react';
import { Link } from 'react-router-dom';
import { posts } from '../posts';
import './Blog.css';

function BlogList() {
  return (
    <main className="blog">
      <header className="blog-header">
        <h1>Blog</h1>
        <p className="blog-subtitle">Thoughts and notes.</p>
      </header>
      <ul className="blog-list">
        {posts.map((post) => (
          <li key={post.slug} className="blog-list-item">
            <Link to={`/blog/${post.slug}`} className="blog-list-link">
              <h2 className="blog-list-title">{post.title}</h2>
              <div className="blog-list-meta">{post.date}</div>
              <p className="blog-list-summary">{post.summary}</p>
            </Link>
          </li>
        ))}
        {posts.length === 0 && (
          <li className="blog-empty">No posts yet — check back soon.</li>
        )}
      </ul>
    </main>
  );
}

export default BlogList;
